export enum GlobalNotificationType {
    Error = 0,
    Warning = 1,
    Hint = 2,
}
